import React from 'react';
import './Symptoms.scss';
import IconList from '../../components/IconList/IconList';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import iconOne from '../../assets/symptoms/1.png';
import iconTwo from '../../assets/symptoms/2.png';
import iconThree from '../../assets/symptoms/3.png';
import iconFour from '../../assets/symptoms/4.png';
import iconFive from '../../assets/symptoms/5.png';

const Symptoms = () => {
    const whyChooseData = [
        {
            'icon' : iconOne,
            'title' : 'Expert MDS Specialist',
            'description':'Dr. Vinamrata (MDS) from Govt. Dental College, Ahmedabad with specialized training in Periodontology & Implantology' 
        },
        {
            'icon' : iconTwo,
            'title' : 'Advanced Equipment',
            'description':'State-of-the-art dental technology and modern equipment for precise and effective treatments' 
        },
        {
            'icon' : iconThree,
            'title' : 'Hygienic Care',
            'description':'Sterilized environment following international standards with strict hygiene protocols' 
        },
        {
            'icon' : iconFour,
            'title' : 'Affordable Plans',
            'description':'Family and student dental plans starting from just ₹99 with comprehensive coverage' 
        },
        {
            'icon' : iconFive,
            'title' : 'Personalized Care',
            'description':'Individual attention and customized treatment plans for each patient\'s unique needs' 
        }
    ]

    return (
        <section className='symptoms-section section-common pt-100 pb-70'>
            <div className="container">
                <SectionTitle 
                    subTitle="Why Choose TRUECARE"
                    title="💎 Why Choose TRUECARE DENTAL & IMPLANT CENTER?"
                    description="Experience exceptional dental care with our expert team, modern facilities, and patient-centered approach in Yamunanagar."
                />

                <div className="row">
                    {
                        whyChooseData.map(singleItem => 
                            <IconList 
                                icon={singleItem.icon}
                                title={singleItem.title}
                                description={singleItem.description}
                            />
                        )
                    }
                </div>
            </div>
        </section>
    );
};

export default Symptoms;